import { LayoutChangeEvent, Pressable, Text, View } from "react-native";
import React, { useRef, useState } from "react";
import { color_333333, color_main, transparent, white } from "../assets/style/colors";
import { useWindowDimensions } from 'react-native';
interface LetterProps {
    section: any[],
    scrollToLocation: (sectionIndex: number) => void
}
// 延迟计算，避免在模块加载时 Dimensions 未初始化
export const Letter = (props: LetterProps) => {
    const { width, height } = useWindowDimensions();
    const { section, scrollToLocation } = props
    const [currentLetter, setCurrentLetter] = useState<string>();
    const [show, setShow] = useState(false);
    const [itemHeight, setItemHeight] = useState<number>(0);
    const itemYMap = useRef(new Map<string, number>()).current

    function onPress(letter: string, index: number) {
        scrollToLocation(index);
        setCurrentLetter(letter)
        setShow(true)
        setTimeout(() => {
            setShow(false)
        }, 1000);
    }
    const onLayout = (event: any) => {
        const { height } = event.nativeEvent.layout;
        setItemHeight(height / 26)
    };

    const onItemLayout = (event: LayoutChangeEvent, letter: string) => {
        const { y } = event.nativeEvent.layout;
        itemYMap.set(letter, y)
    };
    function getTop(letter: string): number {
        const y = itemYMap.get(letter)
        if (y) {
            return y - itemHeight / 2
        }
        return 0
    }
    return (<View
        onLayout={onLayout}
        style={{
            alignItems: 'center',
            position: 'absolute',
            end: 0,
            top: 0,
            bottom: 0,
            overflow: 'visible',
            justifyContent: 'center'
        }}
    >
        {section.map((item, index) => {
            return (
                <Pressable
                    key={index}
                    onPress={() => onPress(item.title, index)}
                    onLayout={(event) => { onItemLayout(event, item.title) }}
                    style={{
                        alignItems: 'center',
                        justifyContent: 'center',
                        paddingHorizontal: 10,
                        height: itemHeight,
                    }}>
                    <View
                        style={{
                            borderRadius: 20,
                            width: 20,
                            height: 20,
                            alignItems: 'center',
                            justifyContent: 'center',
                            backgroundColor: currentLetter === item.title ? color_main : transparent,
                        }}>
                        <Text
                            style={{
                                fontSize: 12,
                                color: currentLetter === item.title ? white : color_333333,
                            }}>{item.title}</Text>
                    </View>
                </Pressable>

            )
        })}
        {show && currentLetter && (
            // <View style={{
            //     position: 'absolute',
            //     right: 30,
            //     top: getTop(currentLetter),
            //     borderRadius: 20,
            //     width: 60,
            //     height: 40,
            //     flexDirection: 'row',
            // }}>
            //     <View style={{
            //         width: 40,
            //         borderRadius: 20,
            //         backgroundColor: '#999999',
            //         alignItems: 'center',
            //         justifyContent: 'center',
            //     }}>
            //         <Text
            //             style={{
            //                 fontSize: 22,
            //                 color: '#FFFFFF',
            //             }}>{currentLetter}</Text>
            //     </View>
            //     <View style={{
            //         position: 'absolute',
            //         top: 3,
            //         bottom: 3,
            //         right: 0,
            //         width: 30,
            //         borderLeftColor: '#999999',
            //         borderLeftWidth: 22,
            //         borderTopColor: 'transparent',
            //         borderTopWidth: 16,
            //         borderBottomColor: 'transparent',
            //         borderBottomWidth: 16,
            //     }}>
            //     </View>
            // </View>

            <View style={{
                position: 'absolute',
                start: -width / 2 + 30,
                end: 0,
            }}>
                <View style={{
                    width: 60,
                    borderRadius: 10,
                    backgroundColor: '#999999',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: 60,
                }}>
                    <Text
                        style={{
                            fontSize: 22,
                            fontWeight: 'bold',
                            fontFamily:'',
                            color: '#FFFFFF',
                        }}>{currentLetter}</Text>
                </View>
            </View>
        )}
    </View>)
}